<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>

                <div class="row">
                    <div class="col-12 mb-4">
                        <v-card>
                            <v-card-title>
                                    Envoyer le fichier
                                <v-spacer></v-spacer>
                            </v-card-title>

                            <v-form ref="form" v-model="valid" :lazy-validation="lazy" style="padding-bottom: 2%;">



                                <v-col cols="12" sm="12" md="12">
                                    <v-col class="d-flex" cols="12" sm="16">
                                        <v-select
                                                :rules="champRules"
                                                v-model="editedItem.champ"
                                                :items="items"
                                                label="Champ concerné"
                                        ></v-select>
                                    </v-col>
                                    <v-file-input label="Fichier excel" placeholder="Choisir"
                                                  :rules="fileRules"
                                                  v-model="editedItem.file"
                                                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                  id="input_file"></v-file-input>
                                </v-col>

                                <div class="col-12" style="text-align: right">
                                    <v-btn @click="save" :disabled="!valid" color="success" style="margin-left: 3%"> Envoyer maintenant
                                    </v-btn>
                                </div>
                            </v-form>

                        </v-card>
                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>

            </div> <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

    </div>
</template>

<script>
    //import {mapState} from "vuex";
    import $ from "jquery";


    export default {
        name: "Produit",
        components: {},
        data() {
            return {
                submitting: false,
                overlay: false,
                errors: {},
                valid: true,
                lazy: false,
                user: JSON.parse(localStorage.getItem("user")),
                dialog: '',
                id: undefined,
                snackbar: false,
                textSnack: '',
                editedIndex: -1,
                items: [{'text':'Produits','value':"produit"},
                    {'text':'Categorie','value':"cat"},
                    {'text':'Tier','value':"tier"},
                    {'text':'Pharmacie','value':"pharma"},
                    ],
                editedItem: {
                    file: '',
                    champ: '',

                },
                defaultItem: {
                    file: '',
                    champ: '',

                }
                ,
                fileRules: [
                    v => !!v || 'Fichier requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                champRules: [
                    v => !!v || 'Champ requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],

            }
        }
        ,
        computed: {

        }
        ,
        mounted() {

        }
        ,
        watch: {

        }
        ,
        methods: {
            initialize() {

            },
            save() {


                this.overlay = true;
                let data = new FormData();
                data.append("file", this.editedItem.file);
                data.append("user", this.user._id);
                let mineroute = "";
                console.log(this.editedItem.champ);

                switch (this.editedItem.champ)
                {
                    case 'produit':
                        mineroute = 'uploads/setUpload';
                        break;

                    case 'cat':
                        mineroute = 'uploads/setUploadCat';
                        break;

                    case 'fp':
                        mineroute = 'uploads/setUploadFq';
                        break;

                    case 'tier':
                        mineroute = 'uploads/setUploadTier';
                        break;

                    case 'pharma':
                        mineroute = 'uploads/setUploadPharma';
                        break;

                    default:
                        this.overlay = false;
                        this.snackbar = true;
                        this.textSnack = "Erreur, choix incorrect";
                        return

                }



                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.overlay = false;
                    if (response.data.error) {
                            this.errors.operation = response.data.message;
                    } else {

                        this.reset();
                    }
                })
            },
            validateStep1() {
                this.errors = {};
                if (this.editedItem.reference === null || this.editedItem.reference.trim().length === 0) {
                    this.errors.reference = "Référence  requise";
                }
                if (this.editedItem.denomination === null || this.editedItem.denomination.trim().length === 0) {
                    this.errors.denomination = "Dénomination  requise";
                }
                if (this.editedItem.default_price === null || this.editedItem.default_price.trim().length === 0) {
                    this.errors.default_price = "Prix  requis";
                }

                let tab_composition = [];
                let tab_quantity = [];
                let i = 0;
                $('input[name^="composition"]').each(function () {
                    tab_composition[i] = $(this).val();
                    i++;
                });
                i = 0;
                $('input[name^="quantity"]').each(function () {
                    tab_quantity[i] = $(this).val();
                    i++;
                });
                this.composition = [];
                this.quantity = [];
                this.composition = tab_composition;
                this.quantity = tab_quantity;
                this.editedItem.composition = this.composition;
                this.editedItem.quantity = this.quantity;
                if (this.composition.length > 0 || this.quantity.length > 0) {
                    console.log("c " + this.composition[0]);
                    console.log("q " + this.quantity[0]);
                    if (this.composition[0] === null || this.composition[0] === ""
                        || this.composition[0].trim().length === 0
                        || this.quantity[0] === null || this.quantity[0] === ""
                        || this.quantity[0].trim().length === 0) {
                        this.errors.cqq = "Compositions quantitatives et qualitatives  requises";
                    }
                } else {
                    this.errors.cqq = "Compositions quantitatives et qualitatives  requises";
                }

                console.log("fp : " + this.editedItem.fp);
                if (this.editedItem.fp === null || this.editedItem.fp.trim().length === 0) {
                    this.errors.fp = "Forme pharmaceutique requise";
                }


                if (this.editedItem.categorie_slug === null || this.editedItem.categorie_slug.trim().length === 0) {
                    this.errors.categorie_slug = "Catégorie requise";
                }


                console.log(this.editedItem.photo);
                if (this.editedItem.photo === null || this.editedItem.photo === undefined) {
                    if (this.editedIndex < 0) {
                        this.errors.photo = "Photo requise";
                    } else {
                        this.editedItem.photo = null;
                    }

                }


                this.step1 = Object.keys(this.errors).length === 0;
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor() {
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>